/** @format */

import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DirectionReveal from "direction-reveal";
import Modal from "react-modal";
import HuluModal from "./modal/website/HuluModal";
import CityShopModal from "./modal/webapps/CityShopModal";
import ContactPageModal from "./modal/website/ContactPageModal";
import BuyMoreModal from "./modal/webapps/BuyMoreModal";
import HealthWebsiteModal from "./modal/website/HealthWebsiteModal";
import ExpenseTrackerModal from "./modal/webapps/ExpenseTrackerModal";
import ReactPortfolioModal from "./modal/website/ReactPortfolioModal";
import CenturyDesignersModal from "./modal/website/CenturyDesignersModal";
import FirstPortfolioModal from "./modal/website/FirstPortfolioModal";
import EdDashModal from "./modal/webapps/EdDashModal";

const Works = () => {
	const [openHulu, setOpenHulu] = useState(false);
	const [openCityShop, setOpenCityShop] = useState(false);
	const [openContactPage, setOpenContactPage] = useState(false);
	const [openBuyMore, setOpenBuyMore] = useState(false);
	const [openHealthWebsite, setOpenHealthWebsite] = useState(false);
	const [openExpenseTracker, setOpenExpenseTracker] = useState(false);
	const [openReactPortModal, setOpenReactPortModal] = useState(false);
	const [openCenturyDesignersModal, setOpenCenturyDesignersModal] = useState(false);
	const [openFirstPortfolio, setOpenFirstPortfolio] = useState(false);
	const [openEdDash, setOpenEdDash] = useState(false);

	function toggleHuluModal() {
		setOpenHulu(!openHulu);
	}

	function toggleCityShop() {
		setOpenCityShop(!openCityShop);
	}

	function toggleContactPage() {
		setOpenContactPage(!openContactPage);
	}

	function toggleBuyMore() {
		setOpenBuyMore(!openBuyMore);
	}

	function toggleHealthWebsite() {
		setOpenHealthWebsite(!openHealthWebsite);
	}

	function toggleExpenseTracker() {
		setOpenExpenseTracker(!openExpenseTracker);
	}

	function toggleReactPortfolio() {
		setOpenReactPortModal(!openReactPortModal);
	}

	function toggleCenturyDesigners() {
		setOpenCenturyDesignersModal(!openCenturyDesignersModal);
	}

	function toggleFirstPortfolio() {
		setOpenFirstPortfolio(!openFirstPortfolio);
	}

	function toggleEdDash() {
		setOpenEdDash(!openEdDash);
	}

	useEffect(() => {
		// Init with default setup
		DirectionReveal();

		// Init with all options at default setting
		DirectionReveal({
			selector: ".direction-reveal",
			itemSelector: ".direction-reveal__card",
			animationName: "slide",
			animationPostfixEnter: "enter",
			animationPostfixLeave: "leave",
			touchThreshold: 500,
		});
	}, []);

	return (
		<Tabs>
			<TabList className="portfolio-tab-list">
				<Tab>ALL</Tab>
				<Tab>WEBSITES</Tab>
				<Tab>WEBAPPS</Tab>
				<Tab>FRONTEND DESIGNS</Tab>
				{/* <Tab>MOCKUP</Tab> */}
			</TabList>

			<div className="portfolio-tab-content">
				<TabPanel>
					<ul className="row grid justify-content-center">
						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="0">
							<figure onClick={toggleHuluModal}>
								<img src="img/projects/hulu-clone-website.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">Hulu Clone</span>
								</div>
							</figure>

							{/* Start HuluModal */}
							<Modal
								isOpen={openHulu}
								onRequestClose={toggleHuluModal}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleHuluModal}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<HuluModal />
									</div>
								</div>
							</Modal>
							{/* End  HuluModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleCityShop}>
								<img src="img/projects/cityshop.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> CityShop</span>
								</div>
							</figure>

							{/* Start CityShopModal */}
							<Modal
								isOpen={openCityShop}
								onRequestClose={toggleCityShop}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleCityShop}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<CityShopModal />
									</div>
								</div>
							</Modal>
							{/* End  CityShopModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleEdDash}>
								<img src="img/projects/edhome.png" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> Ed.Admin</span>
								</div>
							</figure>

							{/* Start edDashModal */}
							<Modal
								isOpen={openEdDash}
								onRequestClose={toggleEdDash}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleEdDash}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<EdDashModal />
									</div>
								</div>
							</Modal>
							{/* End  edDash Modal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleContactPage}>
								<img src="img/projects/contact page.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">Contact Page</span>
								</div>
							</figure>

							{/* Start ContactPageModal */}
							<Modal
								isOpen={openContactPage}
								onRequestClose={toggleContactPage}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleContactPage}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ContactPageModal />
									</div>
								</div>
							</Modal>
							{/* End  ContactPageModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleBuyMore}>
								<img src="img/projects/buymore.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> BuyMore</span>
								</div>
							</figure>

							{/* Start BuyMoreModal */}
							<Modal
								isOpen={openBuyMore}
								onRequestClose={toggleBuyMore}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleBuyMore}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<BuyMoreModal />
									</div>
								</div>
							</Modal>
							{/* End  BuyMoreModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleHealthWebsite}>
								<img
									src="img/projects/health consultation.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">Health Consultation</span>
								</div>
							</figure>

							{/* Start HealthConsultationModal */}
							<Modal
								isOpen={openHealthWebsite}
								onRequestClose={toggleHealthWebsite}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleHealthWebsite}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<HealthWebsiteModal />
									</div>
								</div>
							</Modal>
							{/* End  HealthConsultationModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleExpenseTracker}>
								<img src="img/projects/expenseTracker.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> Expense Tracker</span>
								</div>
							</figure>

							{/* Start ExpenseTrackerModal */}
							<Modal
								isOpen={openExpenseTracker}
								onRequestClose={toggleExpenseTracker}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleExpenseTracker}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ExpenseTrackerModal />
									</div>
								</div>
							</Modal>
							{/* End  ExpenseTrackerModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleReactPortfolio}>
								<img
									src="img/projects/react-portfolio-website.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">React Portfolio</span>
								</div>
							</figure>

							{/* Start ReactPortfolioModal */}
							<Modal
								isOpen={openReactPortModal}
								onRequestClose={toggleReactPortfolio}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleReactPortfolio}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ReactPortfolioModal />
									</div>
								</div>
							</Modal>
							{/* End  ReactPortfolioModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleFirstPortfolio}>
								<img src="img/projects/portfolio.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">First Portfolio</span>
								</div>
							</figure>

							{/* Start CenturyDesignersModal */}
							<Modal
								isOpen={openFirstPortfolio}
								onRequestClose={toggleFirstPortfolio}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleFirstPortfolio}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<FirstPortfolioModal />
									</div>
								</div>
							</Modal>
							{/* End  CenturyDesignersModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleCenturyDesigners}>
								<img
									src="img/projects/century designers co ltd.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">Century Designers</span>
								</div>
							</figure>

							{/* Start CenturyDesignersModal */}
							<Modal
								isOpen={openCenturyDesignersModal}
								onRequestClose={toggleCenturyDesigners}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleCenturyDesigners}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<CenturyDesignersModal />
									</div>
								</div>
							</Modal>
							{/* End  CenturyDesignersModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}
					</ul>
				</TabPanel>
				{/* End All Project */}

				{/* Website tab */}
				<TabPanel>
					<ul className="row grid justify-content-center">
						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="0">
							<figure onClick={toggleHuluModal}>
								<img src="img/projects/hulu-clone-website.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">Hulu Clone</span>
								</div>
							</figure>

							{/* Start HuluModal */}
							<Modal
								isOpen={openHulu}
								onRequestClose={toggleHuluModal}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleHuluModal}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<HuluModal />
									</div>
								</div>
							</Modal>
							{/* End  HuluModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleContactPage}>
								<img src="img/projects/contact page.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">Contact Page</span>
								</div>
							</figure>

							{/* Start ContactPageModal */}
							<Modal
								isOpen={openContactPage}
								onRequestClose={toggleContactPage}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleContactPage}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ContactPageModal />
									</div>
								</div>
							</Modal>
							{/* End  ContactPageModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleHealthWebsite}>
								<img
									src="img/projects/health consultation.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">Health Consultation</span>
								</div>
							</figure>

							{/* Start HealthConsultationModal */}
							<Modal
								isOpen={openHealthWebsite}
								onRequestClose={toggleHealthWebsite}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleHealthWebsite}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<HealthWebsiteModal />
									</div>
								</div>
							</Modal>
							{/* End  HealthConsultationModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleReactPortfolio}>
								<img
									src="img/projects/react-portfolio-website.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">React Portfolio</span>
								</div>
							</figure>

							{/* Start ReactPortfolioModal */}
							<Modal
								isOpen={openReactPortModal}
								onRequestClose={toggleReactPortfolio}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleReactPortfolio}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ReactPortfolioModal />
									</div>
								</div>
							</Modal>
							{/* End  ReactPortfolioModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleFirstPortfolio}>
								<img src="img/projects/portfolio.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title">First Portfolio</span>
								</div>
							</figure>

							{/* Start CenturyDesignersModal */}
							<Modal
								isOpen={openFirstPortfolio}
								onRequestClose={toggleFirstPortfolio}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleFirstPortfolio}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<FirstPortfolioModal />
									</div>
								</div>
							</Modal>
							{/* End  CenturyDesignersModal */}
						</li>

						{/* <!-- Portfolio Item Starts --> */}
						<li
							className="direction-reveal"
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure
								className="direction-reveal__card"
								onClick={toggleCenturyDesigners}>
								<img
									src="img/projects/century designers co ltd.jpg"
									alt="Portolio"
								/>
								<div className=" hover-content-wrapper">
									<span className="content-title">Century Designers</span>
								</div>
							</figure>

							{/* Start CenturyDesignersModal */}
							<Modal
								isOpen={openCenturyDesignersModal}
								onRequestClose={toggleCenturyDesigners}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleCenturyDesigners}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<CenturyDesignersModal />
									</div>
								</div>
							</Modal>
							{/* End  CenturyDesignersModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}
					</ul>
				</TabPanel>
				{/* End Websites Project */}

				<TabPanel>
					<ul className="row grid justify-content-center">
						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleBuyMore}>
								<img src="img/projects/buymore.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> BuyMore</span>
								</div>
							</figure>

							{/* Start BuyMoreModal */}
							<Modal
								isOpen={openBuyMore}
								onRequestClose={toggleBuyMore}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleBuyMore}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<BuyMoreModal />
									</div>
								</div>
							</Modal>
							{/* End  BuyMoreModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleExpenseTracker}>
								<img src="img/projects/expenseTracker.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> Expense Tracker</span>
								</div>
							</figure>

							{/* Start ExpenseTrackerModal */}
							<Modal
								isOpen={openExpenseTracker}
								onRequestClose={toggleExpenseTracker}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button
										className="close-modal"
										onClick={toggleExpenseTracker}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<ExpenseTrackerModal />
									</div>
								</div>
							</Modal>
							{/* End  ExpenseTrackerModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}

						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleCityShop}>
								<img src="img/projects/cityshop.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> CityShop</span>
								</div>
							</figure>

							{/* Start CityShopModal */}
							<Modal
								isOpen={openCityShop}
								onRequestClose={toggleCityShop}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleCityShop}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<CityShopModal />
									</div>
								</div>
							</Modal>
							{/* End  CityShopModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}
					</ul>
				</TabPanel>
				{/* End WebApps Projects */}

				<TabPanel>
					<ul className="row grid justify-content-center">
						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleCityShop}>
								<img src="img/projects/cityshop.jpg" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> CityShop</span>
								</div>
							</figure>

							{/* Start CityShopModal */}
							<Modal
								isOpen={openCityShop}
								onRequestClose={toggleCityShop}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleCityShop}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<CityShopModal />
									</div>
								</div>
							</Modal>
							{/* End  CityShopModal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}
						{/* <!-- Portfolio Item Starts --> */}
						<li
							data-aos="fade-right"
							data-aos-duration="1200"
							data-aos-delay="200">
							<figure onClick={toggleEdDash}>
								<img src="img/projects/edhome.png" alt="Portolio" />
								<div className=" hover-content-wrapper">
									<span className="content-title"> Ed.Admin</span>
								</div>
							</figure>

							{/* Start edDashModal */}
							<Modal
								isOpen={openEdDash}
								onRequestClose={toggleEdDash}
								contentLabel="My dialog"
								className="custom-modal dark"
								overlayClassName="custom-overlay dark"
								closeTimeoutMS={500}>
								<div>
									<button className="close-modal" onClick={toggleEdDash}>
										<img src="/img/cancel.svg" alt="close icon" />
									</button>
									{/* End close icon */}

									<div className="box_inner portfolio">
										<EdDashModal />
									</div>
								</div>
							</Modal>
							{/* End  edDash Modal */}
						</li>
						{/* <!-- Portfolio Item Ends --> */}
					</ul>
				</TabPanel>
				{/* End frontend designs Projects */}

				<TabPanel>
					<ul className="row grid justify-content-center">others</ul>
				</TabPanel>
				{/* End other Projects */}
			</div>
		</Tabs>
	);
};

export default Works;
